RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    utils.FetchByPostMixin = {
        fetch: function (options) {
            const me = this;
            options = options || {};

            _.extend(options, {
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(options.data)
            });

            return Backbone.Collection.prototype.fetch.call(me, options);
        }
    };
});
